export const NOTIFICACION_TIPOS = ['Crítica', 'Urgente', 'Preventiva', 'Informativa'];

export const NOTIFICACION_TIPO_COLORS = {
  'Informativa': '#17a2b8',
  'Crítica': '#dc3545',
  'Urgente': '#fd7e14',
  'Preventiva': '#ffc107',
};

export function getTipoColor(tipo) {
  const key = Object.keys(NOTIFICACION_TIPO_COLORS).find(
    k => k.toLowerCase() === String(tipo).toLowerCase()
  );
  return key ? NOTIFICACION_TIPO_COLORS[key] : '#6c757d';
}
